export default __webpack_public_path__ + "static/media/trekking.98177962.jpg";